import React from 'react';
import { PropTypes } from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

import ErrorGraphic from '../ErrorGraphic';

const UnexpectedErrorPage = ({ history, caption }) => (
  <div>
    <ErrorGraphic />
    <div className="message-404-box">
      <p>{ caption }</p>
      <div className="buttons-con">
        <div className="action-link-wrap">
          <button
            type="button"
            className="btn link-go-back"
            onClick={ () => { history.goBack(); } }
            title="Go back"
          >
            Go Back
          </button>
          <Link to="/" className="link-button">Go to home page</Link>
        </div>
      </div>
    </div>
  </div>
);

UnexpectedErrorPage.propTypes = {
  caption: PropTypes.string,
  history: PropTypes.shape().isRequired
};

UnexpectedErrorPage.defaultProps = {
  caption: "Something's not quite right. Please try again or speak to your system administrator."
};

export default withRouter(UnexpectedErrorPage);
